import { DataBean } from "../DataBean";

export class DocumentFactory extends DataBean {
  public async getDocuments(
    year: number,
    mnemonic: string,
    consecutive: number,
    accountaid: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getDocuments_Number_String_Number_Number",
      [year, mnemonic, consecutive, accountaid]
    );
  }

  
  public async getDocumentsAndConsecutive(
    year: number,
    mnemonic: string,
    consecutive: number,
    accountID: number,
    documentState: number,
    idDocument: number,
    externalReference: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getDocuments_Number_String_Number_Number_Number_Number_Number",
      [
        year, 
        mnemonic,
        consecutive,
        accountID,
        documentState,
        idDocument,
        externalReference,
      ]
    );
  }

  public async getDocumentHeaderByConsecutive(
    year: number,
    mnemonic: string,
    consecutive: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getDocumentHeaderByConsecutive_Number_String_Number",
      [year, mnemonic, consecutive]
    );
  }

  public async getPdfAccountantDocument(
    documentLocation: number,
    mnemonic: string,
    date: any,
    idAccount: number | null
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_getPdfAccountantDocument_Number_String_java.util.Date_Number",
      [documentLocation, mnemonic, date, idAccount]
    );
  }
  public async exportSupplierPaymentOrder(
    idSupplierPaymentOrder: number,
    supplierPaymentOrderDate: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_exportSupplierPaymentOrder_Number_java.util.Date",
      [idSupplierPaymentOrder, supplierPaymentOrderDate]
    );
  }
  public async getAccountantDocumentMenu(
    idDocument: number,
    documentDate: any,
    idAccount: number | null
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.Map_getAccountantDocumentMenu_Number_java.util.Date_Number",
      [idDocument, documentDate, idAccount]
    );
  }
  public async getDocumentInfoReport(
    page: number | null,
    rows: number | null,
    year: number,
    month: number,
    props
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_getDocumentInfoReport_Number_Number_Number_Number_java.util.Map",
      [page, rows, year, month, props]
    );
  }
  public async getDocumentTemplateFileTypeList(
    idDocumentTemplate: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getDocumentTemplateFileTypeList_Number",
      [idDocumentTemplate]
    );
  }
  public async getDocumentTemplateFileFormat(arg: null): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getDocumentTemplateFileFormat_Number",
      [arg]
    );
  }

  public async getAccountantDocumentByLocation(
    idDocument: number,
    date: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_getAccountantDocumentByLocation_Number_java.util.Date",
      [idDocument, date]
    );
  }

  public async getDocumentHeaderByMnemonic(
    year: number,
    month: number,
    idAccount: number,
    mnemonic: string,
    consecutive: number,
    page: number,
    recordsPerPage: number,
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getDocumentHeaderByMnemonic_Number_Number_Number_String_Number_Number_Number",
      [year, month, idAccount, mnemonic, consecutive, page, recordsPerPage]
    );
  }

  public async getDocumentHeaderByMnemonicAndProject(
    year: number,
    month: number,
    idAccount: number,
    mnemonic: string,
    consecutive: number,
    accountIDStr: string,
    idProject: number,
    page: number,
    recordsPerPage: number,
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getDocumentHeaderByMnemonicAndProject_Number_Number_Number_String_Number_String_Number_Number_Number",
      [year, month, idAccount, mnemonic, consecutive, accountIDStr, idProject, page, recordsPerPage]
    );
  }

  public async setParentDocument(idDocument: number, documentDate: any, parentIDDocument: number, parentDocumentDate: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_setParentDocument_Number_java.util.Date_Number_java.util.Date",
      [idDocument, documentDate, parentIDDocument, parentDocumentDate]
    );
  }

  public async releaseParentDocument(idDocument: number, documentDate: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_releaseParentDocument_Number_java.util.Date",
      [idDocument, documentDate]
    );
  }
  public async importAccountBank(idEmployee: number, data: string,setDefaultAffiliate:boolean): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_importAccountBank_Number_String_Boolean",
      [idEmployee,data,setDefaultAffiliate]
    );
  }
  public async importAbstracAccount(idEmployee: number, data: string): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.List_importAbstracAccount_Number_String",
      [idEmployee,data]
    );
  }
  public async importTalentoHumanoConstants(): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.List_importTalentoHumanoConstants_Number",
      [0]
    );
  }
  public async importTalentoHumano(idEmployee:number,importType:number,jsonData:any): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.List_importTalentoHumano_Number_Number_String",
      [idEmployee,importType,jsonData]
    );
  }


}
